export default {
  SEAT_MOUSE_OVER: 'syos.seatMouseOver',
  SEAT_MOUSE_LEAVE: 'syos.seatMouseLeave',
  SEAT_MOUSE_PRESS: 'syos.seatMousePress',
  SEAT_CLICK: 'syos.seatClick',
  SCREEN_UPDATED: 'syos.screenUpdated',
  SEAT_SELECTED: 'syos.seatSelected',
  SEAT_REMOVED: 'syos.seatRemoved',
  API_REQUEST_STARTED: 'syos.apiRequestStarted',
  API_REQUEST_COMPLETED: 'syos.apiRequestCompleted',
  API_REQUEST_ERROR: 'syos.apiRequestError',
  API_SEAT_LIST_REQUEST_CANCELLED: 'syos.apiSeatListRequestCancelled',
  API_RESERVION_ATTEMPT: 'syos.apiReservationAttempt',
  API_RESERVATION_FAIL: 'syos.apiReservationFail',
  API_RESERVATION_SUCCESS: 'syos.apiReservationSuccess',
  MOBILE_ENTER: 'syos.mobileEnter',
  MOBILE_LEAVE: 'syos.mobileLeave',
  TABLET_ENTER: 'syos.tabletEnter',
  TABLET_LEAVE: 'syos.tabletLeave',
  RESERVE_SEATS: 'syos.reserveSeats',
  CART_UPDATE: 'syos.cartUpdate',
  CART_DETAILS_TOGGLE: 'syos.cartDetailsToggle',
  CART_DETAILS_HIDE: 'syos.cartDetailsHide',
  SCREENS_DATA_LOADED: 'syos.screensDataLoaded',
  SEAT_LIST_DATA_LOADED: 'syos.seatListDataLoaded',
  LEGEND_DETAILS_SHOW: 'syos.legendDetailsShow',
  LEGEND_DETAILS_HIDE: 'syos.legendDetailsHide',
  LEGEND_DRAWER_TRANSITION_END: 'syos.legendDrawerTransitionEnd',
};



// WEBPACK FOOTER //
// ./V7/syos/utils/SyosEvents.js